module.exports = __webpack_public_path__ + "static/media/yellowtaxi.4f7aef08.jpg";